
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/product", function() {
      var page = require("private-next-pages/product.js")
      if(module.hot) {
        module.hot.accept("private-next-pages/product.js", function() {
          if(!next.router.components["/product"]) return
          var updatedPage = require("private-next-pages/product.js")
          next.router.update("/product", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  